<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <div class="control_box">
        <Search-bar
          ref="searchBar"
          :timeRange="timeRange"
          :dateTime="dateTime"
          @search="search"
          @reset="search"
        />
      </div>
      <div class="show_box">
        <a-table :columns="columns" :data-source="tableData" :loading="loading" :rowKey="(tableData) => tableData.id"
                 :pagination="pagination" @change="handleTableChange">
            <template slot="annex_image" slot-scope="record" >
              <img :src="record.annex_image" mode="heightFix" style="height: 40px;" @click="showImgModal(record.annex_image)"/>
            
              <!-- <a-image
                :src="record.annex_image"
                width="200"
                preview
              /> -->
            </template>
            <template slot="action" slot-scope="record">
              <template v-if="Number(record.status) === 4">
                <a-button type="link" class="btn-approve" @click="handleApproval(record, 1)">同意</a-button>
                <a-divider type="vertical" />
                <a-button type="link" class="btn-reject" @click="handleApproval(record, 5)">驳回</a-button>
              </template>
            </template>
        </a-table>
      </div>
    </div>


    <a-modal v-model="visible" title="附件" :footer="null" >
      <img :src="imagePath" style="width: 100%;" />
    </a-modal>
  </div>
</template>

<script>
//引入接口api
import {
  getGuestMealOrder,
  approvalGuestMealOrder,
} from "@/request/api";

//引入封装的组件
import SearchBar from "@/components/common/SearchBar.vue";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
import moment from "moment";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchBar,
    MyBreadcrumb,
  },
  data() {
    const beginDate = moment().format("YYYY-MM-DD");
    const endDate = moment().add(6, "days").format("YYYY-MM-DD");
    return {
      //面包屑
      breadcrumbs: [
        {
          key: 0,
          title: "客餐/接待餐",
        },
        {
          key: 1,
          title: "客餐审批",
        },
      ],
      dateTime: {
        show: true,
      },
      timeRange: {
        show: true,
        placeholderStart: "开始时间",
        placeholderEnd: "结束时间",
        rangeLimit: true
      },
      timeData:['2024-10-24','2024-10-24'],
      //请求参数
      queryParam: {
        page: 1,
        repast_date: "",
        begin_date: beginDate,
        end_date: endDate,
        is_approval: 1,
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      loading: false, //table加载状态
      imagePath: "", //图片路径
      // 表格的列配置
      columns: [

      {
          title: "申请人",
          key: "realname",
          dataIndex: "realname",
        },
        {
          title: "部门",
          key: "office",
          dataIndex: "office",
        },
        {
          title: "客餐类型",
          key: "meal_title",
          dataIndex: "meal_title",
        },
        {
          title: "就餐时间",
          key: "repast_date",
          dataIndex: "repast_date",
        },
        {
          title: "时段",
          key: "meal_time_title",
          dataIndex: "meal_time_title",
        },
        {
          title: "份数",
          key: "count",
          dataIndex: "count",
        },
        {
          title: "金额(元)",
          key: "price",
          dataIndex: "money",
        },
        {
          title: "用餐说明",
          key: "remarks",
          dataIndex: "remarks",
          width:'250px',
          style: { 'maxWidth': '100px','textAlign': 'left' },
        },
        {
          title: "附件",
          key: "annex_image",
          scopedSlots: { customRender: "annex_image" },
          style: { padding: 0 },
        },
        {
          title: "状态",
          key: "status_txt",
          dataIndex: "status_txt",
        },
        {
          title: "审批人",
          key: "approver_realname",
          dataIndex: "approver_realname",
        },
        {
          title: "申请时间",
          key: "created_at",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: {customRender: "action"},
        },
      ],
      //页配置
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },

      visible: false,
      addGuestMeal: false,
      editId: "",
      //更新参数
      addParam: {
        title: "",
        price: 0, //报餐截止时间提前天数
        selectedHuser: []
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    initDefaultRange() {
      const beginDate = moment();
      const endDate = moment().add(6, "days");
      if (this.$refs.searchBar) {
        this.$refs.searchBar.timeData = [beginDate, endDate];
        this.$refs.searchBar.nowDate = "";
        this.$refs.searchBar.searchData.currentDate = "";
        this.$refs.searchBar.searchData.timeRange = {
          startTime: beginDate.format("YYYY-MM-DD"),
          endTime: endDate.format("YYYY-MM-DD"),
        };
      }
    },
    //刷新和搜索一样的方法
    search(val) {
      this.queryParam = {
        page: 1,
        repast_date: val.currentDate || "",
        begin_date: val.timeRange.startTime,
        end_date: val.timeRange.endTime,
        is_approval: 1,
      };
      this.pagination.current = 1;
      this.getTableData();
    },

    //获取表格数据
    getTableData() {
      this.loading = true;
      this.queryParam.no_paging = 0;
      getGuestMealOrder(this.queryParam).then((res) => {
        let resultData = res.data;
        //处理页码
        const pagination = {...this.pagination};
        pagination.total = resultData.total;
        this.pagination = pagination;
        //空列表判断
        if (resultData.data.length == 0) {
          this.loading = false;
          this.tableData = [];
          return;
        }
        //列表数据处理
        this.tableData = resultData.data;
        this.loading = false;
      });
    },

    //分页
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.getTableData();
    },


    //显示模态框
    showImgModal(annex_image) {
      this.imagePath = annex_image;
      this.visible = true;
    },
    handleApproval(record, status) {
      const actionText = status === 1 ? "同意" : "驳回";
      this.$confirm({
        title: `确认${actionText}该申请？`,
        onOk: () => {
          approvalGuestMealOrder({
            order_number: record.order_number,
            status,
          }).then(() => {
          }).catch((err) => {
            if (err.status == 201) {
              this.$message.success(`${actionText}成功`);
              this.getTableData();
            } else {
              this.$message.error(`${actionText}失败`);
            }
          });
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initDefaultRange();
  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mainBox {
  background-color: #f0f2f5;

  .control_box {
    background-color: white;
    padding: 20px;

    .control_box_bottom {
      margin-top: 20px;
    }
  }

  .show_box {
    width: 100%;
    padding-top: 10px;
  }
}
.btn-approve{
  color: #52c41a;
}
.btn-reject{
  color: #ff4d4f;
}
</style>
